import { SET_NOTIFICATION, UNSET_NOTIFICATION } from '../constants';

const initialState = {
    notification: undefined, //TODO change to undefined
};

export default function (state = initialState, action = {}) {
    switch (action.type) {
        case SET_NOTIFICATION:
            return {
                ...state,
                notification: action.data,
            };

        case UNSET_NOTIFICATION:
            return {
                ...state,
                notification: undefined,
            };

        default:
            return state;
    }
}
